<!-- CoproprieteInfo.vue -->
<template>
  <div v-if="post.copropriete || post.charges_copropriete">

    <br>
    <h3>{{ $t("posts.coPropertyInformationTitle") }}</h3>
    <div style="width: 100%" class="surligneTitre">

      <el-row :gutter="20">
        <el-col :span="8" v-if="post.copropriete">
          {{ $labels.copropriete }}
        </el-col>
      </el-row>

      <br/>

      <el-row :gutter="20" v-if="post.alur_syndic_en_procedure != null">
        <el-col :span="6">{{ $labels.alur_syndic_en_procedure }} :</el-col>
        <el-col :span="6">{{ post.alur_syndic_en_procedure ? 'oui' : 'non' }}</el-col>
      </el-row>

      <el-row :gutter="20" v-if="post.charges_copropriete">
        <el-col :span="6">{{ $labels.charges_copropriete }} :</el-col>
        <el-col :span="6">{{ post.charges_copropriete }} {{ post.devise_iso_4217 }}/mois</el-col>
      </el-row>

      <el-row :gutter="20" v-if="post.alur_nb_lots">
        <el-col :span="6">{{ $labels.alur_nb_lots }} :</el-col>
        <el-col :span="6">{{ post.alur_nb_lots }}</el-col>
      </el-row>

    </div>
    <br><br>

  </div>
</template>

<script>
export default {
  name: 'CoProprieteInfo',

  props: {
    post: {
      type: Object,
      required: true
    }
  }
}
</script>
